import { PageHeaderWrapper } from '@ui';
import styled from 'styled-components';

export const DepartmentsStaffWrapper = styled(PageHeaderWrapper)`
  table td:last-child {
    text-align: right;
  }
`;
